import styled from "styled-components";
import InputField from "../InputField";

export const CustomInputField = styled(InputField)`
  border: 1px solid #c9d4db;
  border-radius: 3px;
  background-color: #ffffff !important;
  height: 49px !important;
  padding: 0 !important;
`;

export const FormWrapper = styled.div`
  width: 96%;

  div {
    /* background-color: #ffffff; */
  }

  span {
    color: #f21500;
    font-size: 11px;
    margin-left: 14px;
  }
`;
